import React, { Component } from "react";
import axios from "axios";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Link } from "react-router-dom";

import Breadcrumb from "../component/Breadcrumb";
import Footer from "../component/Footer";
import GetUserToken from "../component/getToken";
import { baseUrl } from "../assets/baseUrl";

// Public list of the subjects available for the selected school level.
// It deliberately uses the same cards as "My Lectures", but links to the
// subject details page so the student can subscribe before opening lectures.
export default class Subjects extends Component {
  state = {
    subjects: [],
    loading: true,
  };

  componentDidMount() {
    this.loadSubjects();
  }

  loadSubjects = () => {
    const { levelId } = this.props.match.params;
    const token = GetUserToken();

    axios
      .get(`${baseUrl}api/Subjects/Search/${levelId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        this.setState({
          subjects: res.data?.items || [],
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Unable to load subjects for level", error);
        this.setState({ loading: false });
      });
  };

  render() {
    const { subjects, loading } = this.state;
    const levelName = subjects[0]?.level?.levelName || "المواد";

    return (
      <div>
        <Breadcrumb head={levelName} />
        <div className="my-lectures mylectures-list">
          <Container>
            <h5 className="list-header">مواد {levelName}</h5>
            <Grid container spacing={3}>
              {subjects.map((subject) => (
                <Grid item xs={12} sm={6} md={4} lg={4} key={subject.id}>
                  <Link
                    to={`/subject-details/${subject.id}`}
                    className="sub-card"
                  >
                    <div
                      className="card-img"
                      style={
                        subject.imagePath
                          ? { backgroundImage: `url(${subject.imagePath})` }
                          : undefined
                      }
                    />
                    <div className="card-body">
                      <h5 className="card-title">{subject.name}</h5>
                    </div>
                  </Link>
                </Grid>
              ))}
            </Grid>

            {!loading && subjects.length === 0 && (
              <h5 className="list-header">لا توجد مواد لهذه المرحلة حاليًا</h5>
            )}
          </Container>

          {loading && (
            <div className="loading">
              <button className="btn" type="button">
                <span className="spinner" />
                <span className="btn__text">برجاء الانتظار...</span>
              </button>
            </div>
          )}
        </div>
        {!loading && <Footer />}
      </div>
    );
  }
}
